import { Card, Col, Container, Row } from 'reactstrap';
import { useAppSelector } from '../../../hooks';
import { SellAThonWeek } from '../../../Types/SellAThon';
import './SellAThon.css';
import { usdFormat } from '../../../Utility/usdFormat';
import SellAThonGraph from '../../../Components/Graphs/SellAThonGraph';

const SellAThonReport = () => {
    const data = useAppSelector((state) => state.sellAThon.salesArr);

    const weekTarget = data?.weeks?.map((week: SellAThonWeek) => (
        Number(week.weekTarget.replace(/,/g, ''))
    )) ?? [];

    const weekSales = data?.weeks?.map((week: SellAThonWeek) => (
        Number(week.weekSales.replace(/,/g, ''))
    )) ?? [];

    const labels = data?.weeks?.map((week: SellAThonWeek, index: number) => 
        String(index + 1)
    );

    const branch = data.branchId;


    return (
        <div>
            <Container>
                {!data
                ? (    
                    <Row>
                        <Col>
                            <span>No Sell-A-Thon Data</span>
                        </Col>
                    </Row>
                ) : (
                    <>
                        <div style={{ marginBlockEnd: 20 }}>
                            <SellAThonGraph 
                                data={weekTarget.reverse()}
                                data2={weekSales.reverse()}
                                labels={labels}
                                branch={branch}
                            />
                        </div>
                        {data.weeks.map((item: SellAThonWeek) => {
                            const target = parseInt(item.weekTarget)
                            const sales = parseInt(item.weekSales)
                            const progress = parseFloat((sales / target).toFixed(2))

                            return (
                                <Card
                                    key={item.week}
                                    // className='itemContainer'
                                >
                                    <Row className='d-flex mt-2'>
                                        <Col>
                                            <span style={{ fontWeight: 'bold'}}>Week: </span>
                                            <span style={{ fontWeight: 'bold'}}>{item.week}</span>
                                        </Col>
                                    </Row>
                                    <Row style={{ justifyContent: 'space-around', marginTop: 5 }}>
                                        <Col>
                                            <Row style={{ marginBottom: 10 }}>
                                                <span>Start Date: </span>
                                                <span>{item.weekStartDate}</span>
                                            </Row>
                                            <Row>
                                                <span>Through Date: </span>
                                                <span>{item.weekEndDate}</span>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row style={{ marginBottom: 10 }}>
                                                <span>Week Target: </span>
                                                <span>${item.weekTarget}</span>
                                            </Row>
                                            <Row>
                                                <span>Projected: </span>
                                                <span>${item.weekProjectedSales}</span>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row style={{ marginBottom: 10 }}>
                                                <span>Week Sales: </span>
                                                <span>${item.weekSales}</span>
                                            </Row>
                                            <Row>
                                                <span>Remaining: </span>
                                                <span>${item.weekRemaining}</span>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row style={{ margin: 10, alignItems: 'center'}}>
                                        <span>{Math.round(progress * 100)}% of Goal Reached</span>
                                    </Row>
                                </Card>
                            )
                        })}
                    </>
                )}
            </Container>
        </div>
        // <ScrollView style={{ flex: 1 }}>
        //     {
        //         !data
        //         ? (
        //             <View>
        //                 <span>No Sell-A-Thon Data</span>
        //             </View>
        //         ) : (
        //             <View>
        //                 {
        //                     data.weeks.map((item: SellAThonWeek) => {
        //                         const target = parseInt(item.weekTarget)
        //                         const sales = parseInt(item.weekSales)
        //                         const progress = parseFloat((sales / target).toFixed(2))

        //                         return (
        //                             <View 
        //                                 key={item.week}
        //                                 style={styles.itemContainer}
        //                             >
        //                                 <View style={{ flexDirection: 'row', justifyContent: 'center', }}>
        //                                     <span style={{ fontWeight: 'bold'}}>Week: </span>
        //                                     <span style={{ fontWeight: 'bold'}}>{item.week}</span>
        //                                 </View>
        //                                 <View style={{flexDirection: 'row', justifyContent: 'space-around', marginTop: 5 }}>
        //                                     <View>
        //                                         <View style={{ marginBottom: 10 }}>
        //                                             <span>Start Date: </span>
        //                                             <span>{item.weekStartDate}</span>
        //                                         </View>
        //                                         <View>
        //                                             <span>Through Date: </span>
        //                                             <span>{item.weekEndDate}</span>
        //                                         </View>
        //                                     </View>
        //                                     <View>
        //                                         <View style={{ marginBottom: 10 }}>
        //                                             <span>Week Sales: </span>
        //                                             <span>${item.weekSales}</span>
        //                                         </View>
        //                                         <View>
        //                                             <span>Week Target: </span>
        //                                             <span>${item.weekTarget}</span>
        //                                         </View>
        //                                     </View>
        //                                 </View>
        //                                 <View style={{ marginTop: 10, alignItems: 'center'}}>
        //                                     <span>{Math.round(progress * 100)}% of Goal Reached</span>
        //                                 </View>
        //                             </View>
        //                         )
        //                     })
        //                 }
        //             </View>
        //         )
        //     }
        // </ScrollView>
    );
};

export default SellAThonReport;